const cities = [
  { name: "Scottsdale", zips: "85250, 85251, 85254, 85255, 85257, 85258, 85259, 85260, 85262, 85266, 85268" },
  { name: "Paradise Valley", zips: "85253" },
  { name: "Fountain Hills", zips: "85268" },
  { name: "Cave Creek / Carefree", zips: "85331, 85377" },
  { name: "Tempe / Mesa East", zips: "85281, 85282, 85283" },
];

const benefits = [
  {
    icon: "ri-computer-line",
    title: "Start 100% Online",
    desc: "No office visit required to begin. Complete your order from your Scottsdale home, North Scottsdale estate, or Gainey Ranch office in minutes.",
  },
  {
    icon: "ri-truck-line",
    title: "Ship Your Documents",
    desc: "Use overnight shipping to send your documents directly to us from any UPS or FedEx location — we handle every detail from there.",
  },
  {
    icon: "ri-shield-check-line",
    title: "Expert Document Review",
    desc: "Every application is reviewed by our team before submission to reduce errors and prevent costly delays for your resort trip or business travel.",
  },
  {
    icon: "ri-calendar-check-line",
    title: "Reserved Agency Access",
    desc: "We hold reserved submission slots at the regional passport agency — no public appointment needed. No driving to Los Angeles.",
  },
];

export default function ScottsdaleLocalAreaSection() {
  return (
    <section id="service-area" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Service Area</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Serving Scottsdale &amp; Northeast Phoenix Metro
          </h2>
        </div>

        <div className="max-w-4xl mx-auto mb-16">
          <div className="bg-[#F7F8FA] rounded-lg p-8 md:p-10 border border-gray-200">
            <p className="text-gray-600 text-base leading-[1.8] mb-5">
              Scottsdale occupies a unique position in the American travel landscape. It is simultaneously a world-class resort destination and a sophisticated business hub — home to the Mayo Clinic campus, the headquarters of major financial and insurance firms, a thriving biotech corridor along Scottsdale Road, and one of the most affluent retirement communities in the American Southwest. The result is a traveler base with high standards, disposable income, and very little patience for bureaucratic delays.
            </p>
            <p className="text-gray-600 text-base leading-[1.8] mb-5">
              The luxury resort and hospitality industry drives substantial last-minute international travel demand. Executives staying at the Four Seasons Troon North, Fairmont Scottsdale Princess, or The Boulders book business trips and spa retreats on compressed timelines. International clients arrive for automotive auctions at Barrett-Jackson, PGA Tour events at TPC Scottsdale, and Waste Management Phoenix Open hospitality. These travelers book quickly — and discover passport issues just as fast.
            </p>
            <p className="text-gray-600 text-base leading-[1.8] mb-5">
              The biomedical and healthcare corridor adds another urgent travel segment. Mayo Clinic physicians travel to international medical conferences and research symposia with publication deadlines that do not move. HonorHealth and Scottsdale Healthcare specialists attend CME programs in Europe and Asia. Biotech executives at the SkySong innovation campus fly to international partner meetings and regulatory submissions. For these professionals, a passport problem is not merely inconvenient — it represents a career obligation missed.
            </p>
            <p className="text-gray-600 text-base leading-[1.8]">
              Fast Passport Center serves all of these Scottsdale traveler profiles with the same expedited, professional service: dedicated agents, document review before submission, reserved agency access, and processing as fast as 24 hours. The nearest passport agency is the Los Angeles Passport Agency — over 370 miles from Scottsdale via I-10. Our courier service eliminates that journey entirely, delivering predictable results for even the most time-sensitive Scottsdale travel plans.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          <div>
            <div className="bg-[#1A365D] rounded-lg p-7 mb-8 text-white">
              <div className="flex items-center gap-3 mb-5">
                <div className="w-11 h-11 flex items-center justify-center rounded-full bg-[#F6C344] flex-shrink-0">
                  <i className="ri-passport-line text-[#1A365D] text-xl"></i>
                </div>
                <div>
                  <p className="font-bold text-base">Fast Passport Center — Scottsdale, AZ</p>
                  <p className="text-white/60 text-xs mt-0.5">Serving Northeast Phoenix Metro Remotely</p>
                </div>
              </div>
              <p className="text-white/70 text-sm mb-1">
                <i className="ri-map-pin-line text-[#F6C344] mr-1.5"></i>
                Remote service — no local office visit required
              </p>
              <p className="text-white/50 text-xs mb-5 ml-5">Serving Scottsdale, Paradise Valley, Fountain Hills, Cave Creek &amp; North Phoenix</p>
              <div className="border-t border-white/10 pt-5">
                <p className="text-white/80 text-sm leading-relaxed mb-4">
                  After signing up online, <strong className="text-white">ship your documents overnight</strong> from any UPS or FedEx location in Scottsdale. Most clients ship from home — no office visit required. The nearest passport agency (Los Angeles) is over 370 miles away. We eliminate that trip entirely.
                </p>
                <a
                  href="https://fastpassportcenter.com/checkout/"
                  className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-5 py-2.5 rounded-md transition-all whitespace-nowrap"
                >
                  Start My Passport <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {benefits.map((b, i) => (
                <div key={i} className="bg-[#F7F8FA] rounded-lg p-5 border border-gray-200">
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#F6C344]/15 mb-3">
                    <i className={`${b.icon} text-[#1A365D] text-base`}></i>
                  </div>
                  <p className="font-bold text-[#1A365D] text-sm mb-1">{b.title}</p>
                  <p className="text-gray-500 text-xs leading-relaxed">{b.desc}</p>
                </div>
              ))}
            </div>
          </div>

          <div>
            <div className="bg-[#F7F8FA] rounded-lg p-7 mb-6 border border-gray-200">
              <h3 className="font-bold text-[#1A365D] text-sm uppercase tracking-wide mb-5">
                <i className="ri-map-pin-2-line text-[#F6C344] mr-2"></i>
                Communities We Serve
              </h3>
              <div className="space-y-1.5">
                {cities.map((city, i) => (
                  <div key={i} className="flex items-center justify-between py-2.5 px-3 bg-white rounded-md">
                    <div className="flex items-center gap-2.5">
                      <i className="ri-checkbox-circle-fill text-[#F6C344] text-sm"></i>
                      <span className="text-[#1A365D] font-medium text-sm">{city.name}</span>
                    </div>
                    {city.zips && (
                      <span className="text-gray-400 text-xs font-mono hidden sm:inline">{city.zips}</span>
                    )}
                  </div>
                ))}
              </div>
              <p className="text-gray-500 text-xs mt-4 leading-relaxed">
                Anywhere in Northeast Phoenix metro — start online, ship overnight, and we handle the rest. No need to drive to the LA Passport Agency.
              </p>
              <div className="mt-4 pt-4 border-t border-gray-100">
                <p className="text-gray-400 text-xs font-semibold uppercase tracking-wider mb-3">Nearby Cities We Serve</p>
                <div className="flex flex-wrap gap-2">
                  {[
                    { name: "Phoenix", href: "/cities/phoenix" },
                    { name: "Mesa", href: "/cities/mesa" },
                    { name: "Chandler", href: "/cities/chandler" },
                    { name: "Gilbert", href: "/cities/gilbert" },
                    { name: "Paradise Valley", href: "/cities/paradise-valley" },
                    { name: "Peoria AZ", href: "/cities/peoria-az" },
                  ].map((link) => (
                    <a
                      key={link.href}
                      href={link.href}
                      className="inline-flex items-center gap-1 text-xs text-[#1A365D] hover:text-[#F6C344] font-medium transition-colors bg-white border border-gray-200 hover:border-[#F6C344] rounded-full px-3 py-1.5 whitespace-nowrap"
                    >
                      {link.name} <i className="ri-arrow-right-line text-[10px]"></i>
                    </a>
                  ))}
                </div>
              </div>
            </div>

            <div className="bg-[#1A365D] rounded-lg p-5">
              <p className="text-white/50 text-xs uppercase tracking-widest font-semibold mb-4">Why Scottsdale Travelers Choose Fast Passport Center</p>
              <div className="grid grid-cols-2 gap-3">
                {[
                  { icon: "ri-government-line", value: "Registered Courier", label: "U.S. Department of State" },
                  { icon: "ri-award-line", value: "A+ Rating", label: "Better Business Bureau" },
                  { icon: "ri-calendar-check-line", value: "20+ Years", label: "Serving Travelers Nationwide" },
                  { icon: "ri-customer-service-2-line", value: "Real Humans", label: "Live Support — Not a Bot" },
                ].map((item, i) => (
                  <a
                    key={i}
                    href="https://fastpassportcenter.com"
                    className="flex items-center gap-2.5 bg-white/5 hover:bg-white/10 rounded-md px-3 py-2.5 transition-colors cursor-pointer"
                  >
                    <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#F6C344]/15 flex-shrink-0">
                      <i className={`${item.icon} text-sm text-[#F6C344]`}></i>
                    </div>
                    <div className="text-left">
                      <span className="text-white text-xs font-bold block leading-tight">{item.value}</span>
                      <span className="text-white/50 text-xs leading-tight block">{item.label}</span>
                    </div>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}